import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { CustomValidator } from "../beans/errors/custom-validator.bean";
import { ValidationError } from "../beans/errors/validation-error.bean";

@Component({
  template: ''
})
export abstract class CqForm 
{
    @Input() public appearance : "standard" | "fill" | "outline" = "standard"
    // Label to display, auto translated with i18n
    @Input() public label      : string;
  
    // Array containing the subset to show
    @Input() public values     : any []
  
    // Select Disabled state 
    @Input() public disabled   : boolean = false;
    // Select Multiple State 
    @Input() public multiple   : boolean = false;
    // Add All Option 
    @Input() public all        : any;

    // Add Info text 
    @Input() public help       : any;
    @Input() public helpIcon   : string = "help_outline";

    // Form Ctrl with Custom Validators
    @Input() public formCtrl   : FormControl;
    @Input() public validators : CustomValidator[];

    // Function to display value in select 
    @Input() public displayFn  : Function;

    // List of actual error on selected form
    public _errors    : ValidationError[]

    constructor(){
        this.initialize()
    }

    hasErrors( controller?: FormControl): boolean
    {

      const ctrl: FormControl = controller ? controller : this.formCtrl
      
      const errors = ctrl?.errors    

      if( this.validators && errors )
      {
        const form_errors = Object.entries(errors);      
        this._errors = this.validators.filter( ( validator ) => {                    
          const find = form_errors.find ( ( el ) => {
            //console.log(validator.validation.validatorName, el[0]);
            
            return validator.validation.validatorName == el[0]
          } )
          return find ? true : false 
        }).map( (validator) => validator.validation )     
        //console.log( this._errors );
        
      }      
            
      return this._errors ? this._errors.length > 0 : false 
    }
  
    _display( value: any){
      if ( ! this.displayFn ) return value 
      return this.displayFn( value ) 
    }

    initialize(){
        if ( this.disabled.toString(  ) == "" ) 
            this.disabled = true       
    
        if ( this.multiple.toString(  ) == "" ) 
            this.multiple = true       
  
    }

    stopPropagation( event: Event ){
      event.stopPropagation()
    }
}